import { createContext } from 'react';
import { DialogContextType } from '../providers';
export const DialogContext = createContext<DialogContextType>({
  dialogState: [],
  isLoading: false,
  setIsLoading: () => {
    console.warn('Dialog ctx is not assigned');
  },
  openDialog: () => {
    console.warn('Dialog ctx is not assigned');
  },
  closeDialog: () => {
    console.warn('Dialog ctx is not assigned');
  },
});
